import { ReduxActionTypes } from "constants/ReduxActionConstants";
import { createAction } from "utils/ActionUtils";

export const InitializeApp = () => createAction(ReduxActionTypes.APP_INIT);

export const InitializeAppSuccess = () =>
  createAction(ReduxActionTypes.APP_INIT_SUCCESS);
